import English from './languages/en.json';
import Dutch from './languages/nl.json';

const langMessages = {
  'en.msg': English,
  'nl.msg': Dutch,
};

export default langMessages;
